import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-print-image',
  templateUrl: './print-image.component.html',
  styleUrls: ['./print-image.component.scss']
})
export class PrintImageComponent implements OnInit {

  constructor( public dialogRef: MatDialogRef<PrintImageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { imageUrl: string }) { }

  ngOnInit() {
  }

  close(): void {
    this.dialogRef.close();
  }
}
